import "../../node_modules/angular/angular";

import "../../node_modules/bootstrap/dist/js/bootstrap";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../node_modules/font-awesome/css/font-awesome.min.css";

import "./services.js";
import FixParserCtrl from "./ui/controllers.js";

export function start() {
  const app = angular.module("fix", []);
  app.controller("FixParserCtrl", FixParserCtrl);
}
